import axios from 'axios';
import {
  defaultRequestResolve,
  defaultRequestReject,
  defaultResponseReject,
} from './interceptors';
import { message } from 'axios'

/**
 * 需要向前兼容代码，暂时另外提取出来改动
 * 待时间允许寻找更好的解决方式
 */
function defaultResponseResolve(response) {

  if (response.status === 200) {
    if (response.data && response.data.data && response.data.code === 200) {
      return response.data.data;
    }
    return response.data;
  }

  message.error(response.statusText);
  throw new Error(response.status);
}


const baseReq = axios.create({
  timeout: 8000
});

baseReq
  .interceptors
  .request
  .use(defaultRequestResolve, defaultRequestReject);

baseReq
  .interceptors
  .response
  .use(defaultResponseResolve, defaultResponseReject);

function getGrade (params) {
  return baseReq.get('/platform/api/sites/package',{params})
}

function getDomainInfo(siteId) {
  return baseReq.get(`/platform/api/sites/${siteId}/domainInfo`)
}

function bindDomain(domain) {
  return baseReq.post(`/site/ajax-commit-domain`, domain)
}

function unBindDomain(params) {
  return baseReq.get(`/site/ajax-unbind-domain`, {params})
}

function changeOrigin(params) {
  return baseReq.get(`/platform/kz_ssl/privateDomain/changeDeploy`, {params})
}

function selfDeployCertificate(data) {
  return baseReq.post(`/platform/kz_ssl/privateDomain/selfDeployCertificate`, data, {jsonType: true})
}

function helpDeployCertificate(params) {
  return baseReq.get(`/platform/kz_ssl/privateDomain/helpDeployCertificate`, {params})
}

function applyCertificate(params) {
  return baseReq.get(`/platform/kz_ssl/privateDomain/deployCertificate`, {params})
}

const APIs = {
  getGrade,
  getDomainInfo,
  bindDomain,
  changeOrigin,
  selfDeployCertificate,
  helpDeployCertificate,
  applyCertificate,
  unBindDomain,
}

export default APIs;